// Vietnamese messages. Typed as Record<MessageKey, string>, so tsc fails if
// a key added to en.ts is omitted here.
import type { MessageKey } from './en'

export const vi: Record<MessageKey, string> = {
  // ── Shell & Navigation ─────────────────────────────────────────────────────
  'nav.overview': 'Tổng quan',
  'nav.settings': 'Cài đặt',
  'nav.signIn': 'Đăng nhập',
  'nav.signUp': 'Đăng ký',
  'nav.menu': 'Menu',
  'nav.home': 'Trang chủ',
  'nav.docs': 'Tài liệu',
  'nav.pricing': 'Bảng giá',
  'nav.dashboard': 'Bảng điều khiển',
  'nav.account': 'Tài khoản',
  'nav.login': 'Đăng nhập',
  'nav.register': 'Bắt đầu ngay',
  'nav.logout': 'Đăng xuất',
  'nav.theme': 'Giao diện',

  // ── Footer ─────────────────────────────────────────────────────────────────
  'footer.tagline': 'Khởi tạo website tương lai tức thì với hiệu ứng sống động đẳng cấp không gian.',
  'footer.product': 'Sản phẩm',
  'footer.product.overview': 'Tổng quan',
  'footer.product.createAccount': 'Tạo tài khoản',
  'footer.product.signIn': 'Đăng nhập',
  'footer.resources': 'Tài nguyên',
  'footer.account': 'Tài khoản',
  'footer.account.account': 'Tài khoản',
  'footer.account.settings': 'Cài đặt',
  'footer.builtWith': 'Kiến tạo bởi nền tảng tạo web uPBo.',

  // ── Theme & Language ───────────────────────────────────────────────────────
  'theme.label': 'Giao diện',
  'theme.light': 'Sáng',
  'theme.dark': 'Tối',
  'theme.system': 'Hệ thống',
  'language.label': 'Ngôn ngữ',

  // ── Home Landing: Đẳng Cấp Không Gian, Tốc Độ & Hiệu Ứng Sống Động ─────────
  'home.status.connected': 'Hạ tầng trực tuyến',
  'home.status.missing': 'Cần cấu hình',
  'home.cta.createAccount': 'Tạo tài khoản',
  'home.cta.tryBelow': 'Trải nghiệm bên dưới',
  'home.arch.shared': 'dùng chung cho cả hai phía',
  'home.hero.title': 'Biến Ý Tưởng Thành Website Đỉnh Cao Trong Vài Giây',
  'home.hero.subtitle':
    'Nền tảng kiến tạo web thế hệ mới kết hợp tốc độ vượt trội, thẩm mỹ chuẩn mực, hiệu ứng chuyển động không gian 3D lôi cuốn và trải nghiệm mượt mà trên mọi thiết bị.',
  'home.hero.startBuilding': 'Khởi Tạo Ngay Miễn Phí',
  'home.hero.exploreShowcase': 'Khám Phá Trực Tiếp',
  'home.hero.inputPlaceholder': 'Mô tả website mong muốn của bạn...',
  'home.hero.createSite': 'Khởi Tạo Website',
  'home.hero.generating': 'Đang khởi tạo giao diện...',
  'home.hero.promptSuggestion1': 'Cà phê thủ công với hiệu ứng ấm áp',
  'home.hero.promptSuggestion2': 'Công nghệ tương lai với hiệu ứng phát sáng',
  'home.hero.promptSuggestion3': 'Studio kiến trúc với chuyển động mượt mà',
  'home.hero.readyBadge': 'Không Gian 3D • Chuyển Động 60fps',
  'home.hero.metricSpeed': '1.8s Khởi Tạo',
  'home.hero.metricFps': 'Chuyển Động 60fps',
  'home.hero.metricStudio': 'Thẩm Mỹ Studio',
  'home.hero.metricMobile': '100% Tương Thích',

  // ── 4 Trụ Cột Đỉnh Cao ────────────────────────────────────────────────────
  'home.pillars.title': 'Tốc Độ Vượt Bậc, Thẩm Mỹ Đỉnh Cao & Hiệu Ứng Sống Động',
  'home.pillars.body':
    'Mọi yếu tố cần thiết để ra mắt một trang web cuốn hút, chinh phục người xem ngay từ ánh nhìn đầu tiên.',
  'home.pillars.speed.title': 'Khởi Tạo Thần Tốc',
  'home.pillars.speed.body':
    'Từ một mô tả ý tưởng ban đầu đến website hoàn chỉnh chỉ trong vài giây. Tiết kiệm hàng trăm giờ lập trình và thiết kế.',
  'home.pillars.motion.title': 'Hiệu Ứng Chuyển Động Sống Động',
  'home.pillars.motion.body':
    'Không gian 3D, quả địa cầu tương tác với vệ tinh quay quanh, ánh sáng phát quang và chuyển động lướt mượt 60 FPS chuẩn điện ảnh.',
  'home.pillars.design.title': 'Thẩm Mỹ Sang Trọng & Tinh Tế',
  'home.pillars.design.body':
    'Màu sắc Deep Space Obsidian và Celestial Cyan hài hòa, kính mờ phản chiếu ánh sáng và tỷ lệ thị giác vàng.',
  'home.pillars.responsive.title': 'Tối Ưu Hoàn Hảo Cho Mobile',
  'home.pillars.responsive.body':
    'Tự động co giãn theo từng kích thước màn hình, hỗ trợ thao tác cảm ứng tự nhiên và tải trang tức thì trên di động.',

  // Legacy pillar keys for compatibility
  'home.pillar.oneCodebase.title': 'Một mã nguồn thống nhất',
  'home.pillar.oneCodebase.body': 'Client và server đồng bộ trong cùng một kiến trúc kiểu dữ liệu chặt chẽ.',
  'home.pillar.ownDatabase.title': 'Cơ sở dữ liệu độc lập',
  'home.pillar.ownDatabase.body': 'Kết nối linh hoạt với bất kỳ máy chủ cơ sở dữ liệu Postgres nào.',
  'home.pillar.accounts.title': 'Tích hợp tài khoản',
  'home.pillar.accounts.body': 'Cơ chế xác thực an toàn qua cookie HttpOnly và phân quyền bảo mật.',
  'home.pillar.aiReadable.title': 'Tối ưu tìm kiếm thông minh',
  'home.pillar.aiReadable.body': 'Tự động tạo sitemap và tương thích với các công cụ tìm kiếm tự động.',

  'home.steps.title': 'Từ ý tưởng đến website hoàn chỉnh',
  'home.step.describe.title': 'Mô tả bằng ngôn ngữ tự nhiên',
  'home.step.describe.body': 'Chỉ cần một câu văn mô tả ý tưởng trang web của bạn.',
  'home.step.build.title': 'Khởi tạo trong môi trường an toàn',
  'home.step.build.body': 'Hệ thống tự động biên dịch, kiểm tra và hoàn thiện mã nguồn.',
  'home.step.ship.title': 'Phát hành ngay lập tức',
  'home.step.ship.body': 'Triển khai tức thì tới hạ tầng biên toàn cầu.',

  'home.demo.title': 'Lớp dữ liệu trực tiếp',
  'home.demo.body': 'Thao tác dữ liệu thời gian thực với phản hồi giao diện tức thì.',
  'home.demo.filesLabel': 'Kiến trúc phân tầng:',
  'home.demo.llmsLink': 'Xem tài liệu llms.txt',

  'demo.empty.signedIn': 'Chưa có dữ liệu. Hãy thêm mục đầu tiên bên dưới.',
  'demo.empty.signedOut': 'Chưa có dữ liệu. Đăng nhập để thêm mục mới.',
  'demo.newItemLabel': 'Tên mục mới',
  'demo.add': 'Thêm',
  'demo.signInToAdd': 'Đăng nhập để thêm mục mới.',
  'demo.delete': 'Xóa {title}',

  // ── Showcase tương tác ────────────────────────────────────────────────────
  'home.showcase.title': 'Trải Nghiệm Đa Dạng Phong Cách Thiết Kế',
  'home.showcase.subtitle':
    'Lựa chọn hướng tiếp cận thẩm mỹ phù hợp nhất cho thương hiệu và thông điệp bạn muốn truyền tải.',
  'home.showcase.techMinimal': 'Công Nghệ Hiện Đại',
  'home.showcase.luxuryEditorial': 'Sang Trọng & Tinh Tế',
  'home.showcase.creativeDynamic': 'Sáng Tạo & Đột Phá',
  'home.showcase.techDesc':
    'Đường nét dứt khoát, gam màu tối sâu thẳm kết hợp điểm nhấn công nghệ, tối ưu cho sản phẩm số thế hệ mới.',
  'home.showcase.luxuryDesc':
    'Phông chữ thanh mảnh, bố cục thoáng đãng và tông màu nhã nhặn, tôn vinh giá trị dịch vụ cao cấp.',
  'home.showcase.creativeDesc':
    'Màu sắc rực rỡ, hiệu ứng chuyển màu sinh động và bố cục phá cách, khơi gợi cảm hứng sáng tạo.',

  'home.features.ready': 'Sẵn sàng triển khai',
  'home.features.ready.desc': 'Kiến trúc tối ưu, bảo mật đa lớp và hiệu năng cao giúp bạn an tâm đưa sản phẩm ra thị trường.',
  'home.features.auth': 'Xác thực bảo mật',
  'home.features.auth.desc': 'Đăng nhập mật khẩu an toàn và đăng nhập nhanh bằng tài khoản Google chỉ với 1 cú chạm.',
  'home.features.crud': 'Quản lý trực tiếp',
  'home.features.crud.desc': 'Thao tác tạo, sửa và quản lý nội dung thời gian thực với phản hồi giao diện tức thì.',

  'home.crud.title': 'Không Gian Dự Án Đang Hoạt Động',
  'home.crud.subtitle': 'Thử nghiệm tạo hoặc loại bỏ dự án mẫu để trải nghiệm phản hồi giao diện thời gian thực.',
  'home.crud.placeholder': 'Nhập tên trang web hoặc dự án mới...',
  'home.crud.add': 'Thêm Dự Án',
  'home.crud.empty': 'Chưa có dự án nào được tạo. Hãy thêm dự án đầu tiên của bạn ở trên!',

  'home.cta.title': 'Sẵn Sàng Ra Mắt Website Của Bạn?',
  'home.cta.body': 'Bắt đầu ngay hôm nay để trải nghiệm quy trình tạo trang web nhanh chóng, hiện đại và đẹp mắt nhất.',
  'home.cta.action': 'Bắt Đầu Ngay Bây Giờ',
  'home.cta.contact': 'Khám Phá Tài Liệu',

  // ── Shared Form Fields ─────────────────────────────────────────────────────
  'field.email': 'Email',
  'field.emailPlaceholder': 'ban@example.com',
  'field.password': 'Mật khẩu',
  'field.currentPassword': 'Mật khẩu hiện tại',
  'field.newPassword': 'Mật khẩu mới',
  'field.displayName': 'Tên hiển thị',
  'field.optional': 'Không bắt buộc',

  // ── Authentication ─────────────────────────────────────────────────────────
  'auth.loginTitle': 'Chào mừng trở lại',
  'auth.loginSubtitle': 'Đăng nhập vào tài khoản uPBo của bạn để tiếp tục',
  'auth.registerTitle': 'Tạo tài khoản uPBo',
  'auth.registerSubtitle': 'Bắt đầu kiến tạo website đẹp mắt chỉ trong vài giây',
  'auth.email': 'Địa chỉ email',
  'auth.password': 'Mật khẩu',
  'auth.name': 'Họ và tên',
  'auth.submitLogin': 'Đăng nhập',
  'auth.submitRegister': 'Tạo tài khoản',
  'auth.orContinueWith': 'Hoặc tiếp tục với',
  'auth.continueWithGoogle': 'Đăng nhập bằng Google',
  'auth.alreadyHaveAccount': 'Đã có tài khoản?',
  'auth.dontHaveAccount': 'Chưa có tài khoản?',
  'auth.signInLink': 'Đăng nhập ngay',
  'auth.signUpLink': 'Đăng ký miễn phí',
  'auth.googleFailed': 'Đăng nhập bằng Google thất bại. Vui lòng thử lại.',
  'auth.invalidCredentials': 'Email hoặc mật khẩu không chính xác',
  'auth.emailInUse': 'Email này đã được đăng ký',
  'auth.weakPassword': 'Mật khẩu phải có ít nhất 8 ký tự',
  'auth.panel.title': 'Làm chủ danh tính và dữ liệu',
  'auth.panel.body': 'Kiến trúc toàn diện giúp bạn hoàn toàn làm chủ tài khoản và dữ liệu cá nhân.',
  'auth.orDivider': 'hoặc',
  'auth.signUpWithGoogle': 'Đăng ký bằng Google',

  // ── Sign In ────────────────────────────────────────────────────────────────
  'login.title': 'Đăng nhập',
  'login.subtitle': 'Tiếp tục với tài khoản của bạn',
  'login.highlight.cookie':
    'Phiên đăng nhập được lưu trữ an toàn trong HttpOnly cookie, chống tấn công đánh cắp phiên XSS.',
  'login.highlight.hash': 'Mật khẩu được mã hóa an toàn với PBKDF2 qua 100.000 vòng lặp kèm muối riêng.',
  'login.highlight.ownData': 'Dữ liệu được lưu trữ độc lập trên hệ cơ sở dữ liệu của bạn.',
  'login.noAccount': 'Chưa có tài khoản?',
  'login.submit': 'Đăng nhập',
  'login.failed': 'Đăng nhập thất bại. Vui lòng thử lại.',

  // ── Register ───────────────────────────────────────────────────────────────
  'register.title': 'Tạo tài khoản',
  'register.subtitle': 'Khởi tạo tài khoản quản trị cho trang web của bạn',
  'register.highlight.firstIsAdmin':
    'Tài khoản đăng ký ĐẦU TIÊN sẽ tự động trở thành Quản trị viên của trang web.',
  'register.highlight.noProvider':
    'Xác thực độc lập ngay trên cơ sở dữ liệu của bạn, không phụ thuộc nhà cung cấp ngoài.',
  'register.highlight.selfServe': 'Có thể tùy chỉnh thông tin hiển thị và mật khẩu bất cứ lúc nào.',
  'register.haveAccount': 'Đã có tài khoản?',
  'register.passwordHint': 'Tối thiểu {count} ký tự.',
  'register.passwordTooShort': 'Mật khẩu phải có ít nhất {count} ký tự',
  'register.submit': 'Tạo tài khoản',
  'register.failed': 'Không thể tạo tài khoản. Vui lòng thử lại.',

  // ── Account ────────────────────────────────────────────────────────────────
  'account.title': 'Tài khoản của bạn',
  'account.eyebrow': 'Tổng quan tài khoản',
  'account.body': 'Quản lý thông tin cá nhân và phiên đăng nhập',
  'account.subtitle': 'Quản lý thông tin cá nhân và phiên đăng nhập',
  'account.email': 'Email',
  'account.name': 'Tên hiển thị',
  'account.created': 'Ngày tham gia',
  'account.security': 'Bảo mật',
  'account.logoutAll': 'Đăng xuất tất cả thiết bị',
  'account.activeSessions': 'Phiên hoạt động',
  'account.adminBadge': 'Quản trị viên',
  'account.signOut': 'Đăng xuất',
  'account.profile.title': 'Hồ sơ cá nhân',
  'account.profile.description': 'Tên hiển thị công khai trên trang web.',
  'account.profile.saved': 'Đã lưu thay đổi',
  'account.profile.failed': 'Không thể lưu. Vui lòng thử lại.',
  'account.save': 'Lưu thay đổi',
  'account.password.title': 'Mật khẩu',
  'account.password.description': 'Cần nhập mật khẩu hiện tại để xác thực chính chủ.',
  'account.password.changed': 'Đã đổi mật khẩu',
  'account.password.failed': 'Không thể đổi mật khẩu. Vui lòng thử lại.',
  'account.password.submit': 'Đổi mật khẩu',

  // ── Guarded pages ──────────────────────────────────────────────────────────
  'guard.forbidden.title': 'Không đủ quyền hạn',
  'guard.forbidden.body': 'Khu vực này chỉ dành cho người quản trị trang web.',

  // ── Not found ──────────────────────────────────────────────────────────────
  'notFound.title': 'Trang không tồn tại',
  'notFound.body': 'Địa chỉ bạn truy cập không tồn tại hoặc đã được chuyển vị trí.',
  'notFound.home': 'Về trang chủ',

  // ── Settings ───────────────────────────────────────────────────────────────
  'settings.title': 'Cài đặt hệ thống',
  'settings.eyebrow': 'Cấu hình nền tảng',
  'settings.body': 'Tinh chỉnh định danh trang web, chỉ số SEO và chính sách tìm kiếm tự động.',
  'settings.subtitle': 'Mọi thay đổi có hiệu lực ngay tức thì — không cần biên dịch lại.',
  'settings.appearance': 'Giao diện hiển thị',
  'settings.language': 'Ngôn ngữ',
  'settings.tab.seo': 'SEO & Tìm Kiếm',
  'settings.tab.ai': 'Bộ thu thập tự động',
  'settings.saved': 'Đã lưu. robots.txt, sitemap.xml và llms.txt đã được cập nhật.',
  'settings.unavailable':
    'Không thể đọc cấu hình — thường do DATABASE_URL chưa được thiết lập. Trang web tiếp tục chạy với cấu hình mặc định trong shared/seo.config.ts.',
  'settings.identity.title': 'Định danh trang web',
  'settings.identity.description':
    'Các câu mô tả chính xác mà công cụ tìm kiếm và trợ lý số trích dẫn khi giới thiệu trang web của bạn.',
  'settings.siteName.label': 'Tên trang web',
  'settings.siteName.hint': 'Hiển thị trên tiêu đề trình duyệt, thẻ chia sẻ và dữ liệu có cấu trúc.',
  'settings.description.label': 'Mô tả tóm tắt',
  'settings.description.hint': 'Từ 1 đến 2 câu ngắn gọn, truyền tải giá trị cốt lõi.',
  'settings.siteUrl.label': 'Tên miền chính',
  'settings.siteUrl.hint': 'Ví dụ https://congty.com — để trống nếu dùng tên miền hiện tại.',
  'settings.keywords.label': 'Chủ đề chính',
  'settings.keywords.hint': 'Phân cách bằng dấu phẩy. Cung cấp cho tệp llms.txt.',
  'settings.sameAs.label': 'Mạng xã hội',
  'settings.sameAs.hint': 'Phân cách bằng dấu phẩy. Giúp kết nối thương hiệu số.',
  'settings.ai.title': 'Hỗ trợ tìm kiếm thông minh',
  'settings.ai.description':
    'Kênh tiếp cận thế hệ mới: cho phép các hệ thống tìm kiếm tự động đọc và trích dẫn nội dung trang web.',
  'settings.ai.allow.title': 'Cho phép bot tìm kiếm',
  'settings.ai.allow.body':
    'Mở tệp robots.txt cho các hệ thống tìm kiếm phổ biến. Tắt mục này sẽ chặn toàn bộ.',
  'settings.ai.prerender.title': 'Hiển thị trước cho bot',
  'settings.ai.prerender.body':
    'Rất quan trọng cho trang web SPA: máy chủ gửi trực tiếp nội dung HTML hoàn chỉnh cho bot đọc hiểu.',
  'settings.ai.filesLabel': 'Tệp dữ liệu đang hoạt động',
  'settings.save': 'Lưu thay đổi',
  'settings.saving': 'Đang lưu...',

  // ── Common ─────────────────────────────────────────────────────────────────
  'common.loading': 'Đang tải...',
  'common.save': 'Lưu thay đổi',
  'common.cancel': 'Hủy',
  'common.delete': 'Xóa',
  'common.error': 'Đã có lỗi xảy ra',
  'common.success': 'Thành công',

  // ── Errors ─────────────────────────────────────────────────────────────────
  'error.auth.email_invalid': 'Địa chỉ email không hợp lệ',
  'error.auth.password_too_short': 'Mật khẩu quá ngắn',
  'error.auth.email_taken': 'Email này đã được đăng ký',
  'error.auth.missing_credentials': 'Thiếu email hoặc mật khẩu',
  'error.auth.invalid_credentials': 'Sai email hoặc mật khẩu',
  'error.auth.current_password_wrong': 'Mật khẩu hiện tại không đúng',
  'error.auth.unauthenticated': 'Bạn cần đăng nhập trước',
  'error.auth.forbidden': 'Bạn không có quyền thực hiện thao tác này',
  'error.db.not_configured': 'Cơ sở dữ liệu chưa được cấu hình. Hãy đặt biến môi trường DATABASE_URL.',
  'error.http.not_found': 'Không tìm thấy đường dẫn',
  'error.http.method_not_allowed': 'Phương thức không được hỗ trợ',
  'error.http.server_error': 'Lỗi máy chủ nội bộ',
  'error.posts.title_required': 'Cần nhập tiêu đề bài viết',
  'error.posts.not_found': 'Không tìm thấy dữ liệu',
  'error.posts.not_owner': 'Bạn không phải chủ sở hữu của mục này',
}
